module.exports = __webpack_public_path__ + "static/produkty_noble-e99195b27e0cc7dddd503bca33478798.png";